var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 17.1008C19.5 18.1503 18.6424 19 17.5849 19H2.41514C1.35756 19 0.5 18.1492 0.5 17.1008V1.89924C0.5 0.850779 1.35756 0 2.41514 0H17.5849C18.6435 0 19.5 0.850779 19.5 1.89924V17.1008ZM6.68016 4.64642C6.68016 5.3443 6.15855 5.91003 5.30099 5.91003C4.49426 5.91003 3.97266 5.3443 3.97266 4.64642C3.97266 3.93216 4.51084 3.38281 5.33525 3.38281C6.15855 3.38281 6.66358 3.93107 6.68016 4.64642ZM4.04007 15.0338V6.90606H6.59617V15.0338H4.04007ZM8.05859 6.90504C8.09285 7.63678 8.126 8.48428 8.126 9.49779V15.0328H10.6832V10.3453C10.6832 10.1127 10.6998 9.88004 10.7672 9.71403C10.9529 9.24878 11.3728 8.76715 12.0789 8.76715C13.0039 8.76715 13.3741 9.48141 13.3741 10.5288V15.0328H15.9302V10.2295C15.9302 7.83664 14.6693 6.72266 12.9873 6.72266C11.6082 6.72266 10.7838 7.50354 10.4478 8.03541H10.397L10.2787 6.90504H8.05859Z",
    fill: "#161515"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.39c3c8e3.svg";
export { ForwardRef as ReactComponent };